import { useMemo } from "react";
import * as Yup from "yup";
import { REQUIRED_MESSAGE, stringSchema } from "@/utils/form";
import { CarouselSlide } from "@/components/Common/CarouselForm/CarouselForm";
import { Formik } from "formik";
import { PhoneNumberStepSlideForm } from "../PhoneNumberStepSlideForm/PhoneNumberStepSlideForm";
import { AuthMachineContext } from "@/store/machine/authMachine/authMachine";
import { AuthEventType } from "@/types/auth";
import { XstateForm } from "@/components/Common/XstateForm/XstateForm";
import { waitForever } from "@/utils";

export const PhoneNumberStepSlide: React.FC<CarouselSlide> = ({ onPrev }) => {
  const authActorRef = AuthMachineContext.useActorRef();
  const profile = AuthMachineContext.useSelector((state) => state.context.profile);
  const initialValues = useMemo(() => {
    const { phone_number, phone_number_code } = profile?.user_metadata || {};

    return {
      phone_number_code: phone_number_code || "",
      phone_number: phone_number || ""
    } as PhoneNumberStepFormType;
  }, [profile]);

  return (
    <Formik<PhoneNumberStepFormType>
      initialValues={initialValues}
      validationSchema={PhoneNumberStepFormSchema}
      onSubmit={async (values, { setSubmitting }) => {
        setSubmitting(true);

        authActorRef.send({
          type: AuthEventType.SET_PHONE_NUMBER,
          value: {
            code: values.phone_number_code,
            number: values.phone_number
          }
        });

        return waitForever();
      }}
      validateOnMount={true}
    >
      {(props) => {
        return (
          <XstateForm machineContext={AuthMachineContext}>
            <PhoneNumberStepSlideForm {...props} onPrev={onPrev} />
          </XstateForm>
        );
      }}
    </Formik>
  );
};

export type PhoneNumberStepFormType = {
  submit: string;
  phone_number_code: string;
  phone_number: string;
};

const PhoneNumberStepFormSchema = Yup.object().shape({
  phone_number_code: stringSchema().required(REQUIRED_MESSAGE),
  phone_number: stringSchema().required(REQUIRED_MESSAGE)
});
